/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlSettingQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GqlSettingQuery = {
  __typename: "Query";
  setting?: {
    __typename: "Setting";
    uri: string;
    operationId: string;
    teamUri: string;
    locations?: Array<string> | null;
    areasOfLaw?: Array<string> | null;
    disableGlobalForms?: boolean | null;
    firmLogoDataUrl?: string | null;
    updatedAt: string;
    defaultClientMessage?: {
      __typename: "DefaultClientMessage";
      matter?: string | null;
      lead?: string | null;
      reminder?: string | null;
      confirmation?: string | null;
      redirectUrl?: string | null;
    } | null;
    staffToNotify?: {
      __typename: "StaffToNotify";
      creator?: boolean | null;
      personResponsible?: boolean | null;
      personAssisting?: boolean | null;
      otherStaffIds?: Array<string> | null;
    } | null;
    branding?: {
      __typename: "Branding";
      brandColor?: string | null;
      headerTextColor?: string | null;
      backgroundColor?: string | null;
      buttonRadius?: string | null;
      inputRadius?: string | null;
      logo?: string | null;
      affectedAreas?: {
        __typename: "AffectedAreas";
        headerBackground?: boolean | null;
        headerUnderline?: boolean | null;
        firmName?: boolean | null;
        sectionTabHighlights?: boolean | null;
        sectionHeadings?: boolean | null;
        buttons?: boolean | null;
      } | null;
      headerDisplay?: {
        __typename: "HeaderDisplay";
        firmLogo?: boolean | null;
        firmName?: boolean | null;
      } | null;
    } | null;
    voiceGuide?: { __typename: "VoiceGuide"; enabled?: boolean | null } | null;
    reminder?: {
      __typename: "ReminderSettings";
      enabled: boolean;
      effectiveFrom?: string | null;
      firstReminderDays?: number | null;
      timezone?: string | null;
      stopOnManualSend?: boolean | null;
      sendFollowUps?: boolean | null;
      repeatEveryDays?: number | null;
      maxFollowUps?: number | null;
    } | null;
  } | null;
};

export const SettingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "setting" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setting" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "settingFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "settingFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Setting" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          { kind: "Field", name: { kind: "Name", value: "operationId" } },
          { kind: "Field", name: { kind: "Name", value: "teamUri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "defaultClientMessage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "matter" } },
                { kind: "Field", name: { kind: "Name", value: "lead" } },
                { kind: "Field", name: { kind: "Name", value: "reminder" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "confirmation" },
                },
                { kind: "Field", name: { kind: "Name", value: "redirectUrl" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "locations" } },
          { kind: "Field", name: { kind: "Name", value: "areasOfLaw" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "disableGlobalForms" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "staffToNotify" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "creator" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "personResponsible" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "personAssisting" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "otherStaffIds" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "branding" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "brandColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affectedAreas" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "headerBackground" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "headerUnderline" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firmName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sectionTabHighlights" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sectionHeadings" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "buttons" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "headerTextColor" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundColor" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "headerDisplay" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firmLogo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firmName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "buttonRadius" },
                },
                { kind: "Field", name: { kind: "Name", value: "inputRadius" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "firmLogoDataUrl" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "voiceGuide" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reminder" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "enabled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "effectiveFrom" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstReminderDays" },
                },
                { kind: "Field", name: { kind: "Name", value: "timezone" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stopOnManualSend" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sendFollowUps" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeatEveryDays" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxFollowUps" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlSettingQuery, GqlSettingQueryVariables>;
